import * as React from "react";

// CSS & SCSS
import "./assets/fonts/inter.css";
import "./assets/fonts/material.css";
import "./assets/fonts/icofont/icofont.css";
import "./assets/fonts/custom.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/sass/styles.scss";
import { AuthProvider } from "./context/AuthContext";
import { ValidationProvider } from "./context/ValidationContext";
import { ProtectedRoute } from "./pages/auth/ProtectedRoute";
// JS & COMPONENTS
import "./i18n";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "./context/Themes";
import { SidebarProvider } from "./context/Sidebar";
import { LoaderProvider } from "./context/Preloader";
import { TranslatorProvider } from "./context/Translator";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { LoginPage, RegisterPage, ForgotPasswordPage } from "./pages/auth";
import {
  OverviewPage,
  DocumentationPage,
  ChangeLogPage,
  ErrorPage,
} from "./pages/others";
import {
  AvatarPage,
  AlertPage,
  ButtonPage,
  ChartPage,
  TablePage,
  FieldPage,
  HeadingPage,
  ColorPage,
} from "./pages/ui";
import {
  EcommercePage,
  AnalyticsPage,
  CRMPage,
  UserListPage,
  UserProfilePage,
  MyAccountPage,
  ProductListPage,
  ProductViewPage,
  ProductUploadPage,
  InvoiceListPage,
  InvoiceDetailsPage,
  OrderListPage,
  MessagePage,
  NotificationPage,
  BlankPage,
  SettingsPage,
} from "./pages/main";
import VendorsPage from "./pages/Admin/Vendors";
import ProductCategoriesPage from "./pages/Admin/Product Categories";
import ProductPage from "./pages/Admin/Products";
import ProductShowPage from "./pages/Admin/Products/show";
import ProductEditPage from "./pages/Admin/Products/edit";
import ProductCreatePage from "./pages/Admin/Products/create";
import PaymentMethodsPage from "./pages/Admin/Payment Methods";





import VendorShow from "./pages/Admin/Vendors/show";



import StockIndex from "./pages/Admin/Stock";
import DashboardPage from "./pages/Admin/Dashboard/dashboard";
import UserManagement from "./pages/Admin/Users";
import RoleIndex from "./pages/Admin/User Roles";
import UserIndex from "./pages/Admin/Users";
import RoleCreate from "./pages/Admin/User Roles/create";
import RoleEdit from "./pages/Admin/User Roles/edit";
import UserCreate from "./pages/Admin/Users/create";
import UserEdit from "./pages/Admin/Users/edit";
import { Navigate } from "react-router-dom";

import StockShow from "./pages/Admin/Stock/StockShow";
import ExpenseEntry from "./pages/Admin/Expense/Create";
import ExpenseList from "./pages/Admin/Expense";
import ExpenseTypeSelect from "./pages/Admin/Expense/ExpenseTypeSelect";


///////Watch


////Issuer
import AddProductPage from "./pages/product/IssueProduct";
import IssuerProductListPage from "./pages/product/IssuerProductList";
import AssignProductsToListerPage from "./pages/product/AssignProductsToListerPage";
import ProductTimelinePage from "./pages/product/ProductTimeLine";
import IssuerProductEdit from "./pages/product/IssuerProductEdit";

////Lister
import ListerProductListPage from "./pages/lister/ListerProductList";
import ListerEditProductPage from "./pages/lister/ListerEditProductPage";



import Timeline from "./pages/Admin/TimeLine/Timeline";
import AllProduct from "./pages/Admin/Product/AllProduct";
import AssignProductsToCheckerPage from "./pages/lister/AssignProductsToCheckerPage";
import CheckerProductList from "./pages/checker/CheckerProductList";
import CheckerProductView from "./pages/checker/CheckerProductView";
import AssignProductsToStockPage from "./pages/checker/AssignProductsToStockPage";
import UserProductList from "./pages/mplacer/UserProductList"
import MplacerProductView from "./pages/mplacer/MplacerProductView";
import BannerPage from "./pages/web/Banners";
import MarqueePage from "./pages/web/Marquee/Marquee";
import ProductCategoryPage from "./pages/web/ProductCategoryPage/ProductCategoryPage";
import ContactUsPage from "./pages/web/ContactUsPage/ContactUsPage";
import AboutUsPage from "./pages/web/AboutUs/AboutUs";
import BrandsPage from "./pages/web/Brands/Brands";
import BlogListPage from "./pages/web/Blogs/BlogListPage";
import BlogFormPage from "./pages/web/Blogs/BlogFormPage";
import ServiceFormPage from "./pages/web/Services/ServiceFormPage";
import ServicesListPage from "./pages/web/Services/ServicesListPage";
import IssuedProductDetailPage from "./pages/product/IssuedProductDetailPage";
import ListedProductsListPage from "./pages/lister/ListedProductsListPage";
import ApprovedProductsListPage from "./pages/checker/CheckedProductsListPage";
import WebOrderEditPage from "./pages/Admin/WebOrders/WebOrderEditPage";
import WebOrdersListPage from "./pages/Admin/WebOrders/WebOrdersListPage";
import MplacedProductList from "./pages/mplacer/MplacedProductList";
import CheckerProductDetailPage from "./pages/checker/CheckerProductDetailPage";
import MplacerProductDetailPage from "./pages/mplacer/MplacerProductDetailPage";
import MarketPlacesPage from "./pages/web/Market Places/MarketPlaces";
import OffersPage from "./pages/web/Offer/OffersPage";
import ListerAddEdit from "./pages/Admin/Admin/listers/ListerAddEdit";
import ListerIndex from "./pages/Admin/Admin/listers/ListerList";
import CheckerAddEdit from "./pages/Admin/Admin/checker/CheckerAddEdit";
import CheckerIndex from "./pages/Admin/Admin/checker/CheckerIndex";
import IssuerAddEdit from "./pages/Admin/Admin/issuer/IssuerAddEdit";
import IssuerIndex from "./pages/Admin/Admin/issuer/IssuerIndex";
import StoreManager from "./pages/Admin/Admin/Stores/StoreManager";
import ProductDetail from "./pages/Admin/Admin/Products/ProductDetail";
import ProductIndex from "./pages/Admin/Admin/Products/ProductIndex";
import ListerProductDetailPage from "./pages/lister/ListerProductDetailPage";
import SellerProductListPage from "./pages/Seller/SellerProductListPage";
import SellerAddProductPage from "./pages/Seller/SellerAddProductPage";
import SellerEditProductPage from "./pages/Seller/SellerEditProductPage";
import SellerProductDetailPage from "./pages/Seller/SellerProductDetailPage";
import StoreSellerNewProductsPage from "./pages/checker/StoreSellerNewProductsPage";
import DispatchProductsPage from "./pages/Seller/DispatchProductsPage";
import ListerDetailPage from "./pages/Admin/Admin/listers/ListerDetailPage";
import CheckerDetailPage from "./pages/Admin/Admin/checker/CheckerDetailPage";
import IssuerDetailPage from "./pages/Admin/Admin/issuer/IssuerDetailPage";
import ExpenseTypesPage from "./pages/web/Expense/ExpenseTypesPage";
import DailyExpensesPage from "./pages/web/Expense/DailyExpensesPage";
import SiteSettingsPage from "./pages/web/SiteSettings/SiteSettingsPage";
import PrivacyPolicyPage from "./pages/web/pages/PrivacyPolicyPage";
import ReturnExchangePage from "./pages/web/pages/ReturnExchangePage";
import TermsConditionsPage from "./pages/web/pages/TermsConditionsPage";
import FaqsPage from "./pages/web/pages/FaqsPage";
import MarketPlacerIndex from "./pages/Admin/Admin/Mplacer/MarketPlacerIndex";
import MarketPlacerAddEdit from "./pages/Admin/Admin/Mplacer/MarketPlacerAddEdit";
const router = createBrowserRouter([
  // MAIN PAGES
  { path: "/ecommerce", element: <EcommercePage /> },
  { path: "/analytics", element: <AnalyticsPage /> },
  { path: "/crm", element: <CRMPage /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/register", element: <RegisterPage /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/user-list", element: <UserListPage /> },
  { path: "/user-profile", element: <UserProfilePage /> },
  { path: "/my-account", element: <MyAccountPage /> },
  { path: "/product-list", element: <ProductListPage /> },
  { path: "/product-view", element: <ProductViewPage /> },
  { path: "/product-upload", element: <ProductUploadPage /> },
  { path: "/invoice-list", element: <InvoiceListPage /> },
  { path: "/invoice-details", element: <InvoiceDetailsPage /> },
  { path: "/order-list", element: <OrderListPage /> },
  { path: "/message", element: <MessagePage /> },
  { path: "/notification", element: <NotificationPage /> },
  { path: "/blank-page", element: <BlankPage /> },
  { path: "/settings", element: <SettingsPage /> },

  // UI PAGES
  { path: "/avatars", element: <AvatarPage /> },
  { path: "/alerts", element: <AlertPage /> },
  { path: "/buttons", element: <ButtonPage /> },
  { path: "/charts", element: <ChartPage /> },
  { path: "/tables", element: <TablePage /> },
  { path: "/fields", element: <FieldPage /> },
  { path: "/headings", element: <HeadingPage /> },
  { path: "/colors", element: <ColorPage /> },

  // OTHER PAGES
  { path: "/", element: <LoginPage /> },
  { path: "/documentation", element: <DocumentationPage /> },
  { path: "/changelog", element: <ChangeLogPage /> },
  { path: "/error", element: <ErrorPage /> },

  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <DashboardPage />
      </ProtectedRoute>
    ),
  },

  /////////////////////////admin///////////////////////////////
  {
    path: "/admin/web-orders",
    element: (
      <ProtectedRoute>
        <WebOrdersListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/web-orders/:id/edit",
    element: (
      <ProtectedRoute>
        <WebOrderEditPage />
      </ProtectedRoute>
    ),
  },

  {
    path: "/listers",
    element: (
      <ProtectedRoute>
        <ListerIndex />
      </ProtectedRoute>
    ),
  },
  {
    path: "/listers/create",
    element: (
      <ProtectedRoute>
        <ListerAddEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/listers/edit/:id",
    element: (
      <ProtectedRoute>
        <ListerAddEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/market-placer",
    element: (
      <ProtectedRoute>
        <MarketPlacerIndex />
      </ProtectedRoute>
    ),
  },
  {
    path: "/market-placer/create",
    element: (
      <ProtectedRoute>
        <MarketPlacerAddEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/market-placer/edit/:id",
    element: (
      <ProtectedRoute>
        <MarketPlacerAddEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/lister/show/:id",
    element: (
      <ProtectedRoute>
        <ListerDetailPage />
      </ProtectedRoute>
    ),
  },

  {
    path: "/checkers",
    element: (
      <ProtectedRoute>
        <CheckerIndex />
      </ProtectedRoute>
    ),
  },
  {
    path: "/checkers/create",
    element: (
      <ProtectedRoute>
        <CheckerAddEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/checkers/edit/:id",
    element: (
      <ProtectedRoute>
        <CheckerAddEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/checkers/show/:id",
    element: (
      <ProtectedRoute>
        <CheckerDetailPage />
      </ProtectedRoute>
    ),
  },

  {
    path: "/issuers",
    element: (
      <ProtectedRoute>
        <IssuerIndex />
      </ProtectedRoute>
    ),
  },
  {
    path: "/issuers/create",
    element: (
      <ProtectedRoute>
        <IssuerAddEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/issuers/edit",
    element: (
      <ProtectedRoute>
        <IssuerAddEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/issuers/show/:id",
    element: (
      <ProtectedRoute>
        <IssuerDetailPage />
      </ProtectedRoute>
    ),
  },

  {
    path: "/stores",
    element: (
      <ProtectedRoute>
        <StoreManager />
      </ProtectedRoute>
    ),
  },

  {
    path: "/products",
    element: (
      <ProtectedRoute>
        <ProductIndex />
      </ProtectedRoute>
    ),
  },
  {
    path: "/product/edit",
    element: (
      <ProtectedRoute>
        <ProductEditPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/products/detail",
    element: (
      <ProtectedRoute>
        <ProductDetail />
      </ProtectedRoute>
    ),
  },

  /////////////////////////issuer///////////////////////////////

  {
    path: "/issue-product",
    element: (
      <ProtectedRoute>
        <AddProductPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/assign-products-to-lister",
    element: (
      <ProtectedRoute>
        <AssignProductsToListerPage />
      </ProtectedRoute>
    ),
  },

  {
    path: "/issue-product-list",
    element: (
      <ProtectedRoute>
        <IssuerProductListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/issue-product-edit",
    element: (
      <ProtectedRoute>
        <IssuerProductEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/issuer/issued-products/:id",
    element: (
      <ProtectedRoute>
        <IssuedProductDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/product-timeline/:id",
    element: (
      <ProtectedRoute>
        <Timeline />
      </ProtectedRoute>
    ),
  },


  /////////////////////////Lister///////////////////////////////
  {
    path: "/lister-products",
    element: (
      <ProtectedRoute>
        <ListerProductListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/lister-product-edit",
    element: (
      <ProtectedRoute>
        <ListerEditProductPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/lister-product-view/:id",
    element: (
      <ProtectedRoute>
        <ListerProductDetailPage />
      </ProtectedRoute>
    ),
  },



  {
    path: "/handover-products-to-checker",
    element: (
      <ProtectedRoute>
        <AssignProductsToCheckerPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/listed-products",
    element: (
      <ProtectedRoute>
        <ListedProductsListPage />
      </ProtectedRoute>
    ),
  },

  /////////////////////////Checker///////////////////////////////


  {
    path: "/checker-products",
    element: (
      <ProtectedRoute>
        <CheckerProductList />
      </ProtectedRoute>
    ),
  },
  {
    path: "/store-seller-products",
    element: (
      <ProtectedRoute>
        <StoreSellerNewProductsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dipatched-products",
    element: (
      <ProtectedRoute>
        <DispatchProductsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/checker-products-edit",
    element: (
      <ProtectedRoute>
        <CheckerProductView />
      </ProtectedRoute>
    ),
  },
  {
    path: "/checker-products-view/:id",
    element: (
      <ProtectedRoute>
        <CheckerProductDetailPage />
      </ProtectedRoute>
    ),
  },

  {
    path: "/handover-products-to-stock",
    element: (
      <ProtectedRoute>
        <AssignProductsToStockPage />
      </ProtectedRoute>
    )
  },
  {
    path: "/approved-products",
    element: (
      <ProtectedRoute>
        <ApprovedProductsListPage />
      </ProtectedRoute>
    ),
  },


  {
    path: "/mplacer-products",
    element: (
      <ProtectedRoute>
        <UserProductList />
      </ProtectedRoute>
    )
  },
  {
    path: "/mplaced-products",
    element: (
      <ProtectedRoute>
        <MplacedProductList />
      </ProtectedRoute>
    )
  },
  {
    path: "/mplacer-products-edit",
    element: (
      <ProtectedRoute>
        <MplacerProductView />
      </ProtectedRoute>
    ),
  },
  {
    path: "/mplacer-products-view",
    element: (
      <ProtectedRoute>
        <MplacerProductDetailPage />
      </ProtectedRoute>
    ),
  },

  /////////////////////////Seller///////////////////////////////

  {
    path: "/seller-products",
    element: (
      <ProtectedRoute>
        <SellerProductListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/seller-product-create",
    element: (
      <ProtectedRoute>
        <SellerAddProductPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/seller-product-edit",
    element: (
      <ProtectedRoute>
        <SellerEditProductPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/seller-product-view/:id",
    element: (
      <ProtectedRoute>
        <SellerProductDetailPage />
      </ProtectedRoute>
    ),
  },

  {
    path: "/timeline",
    element: (

      <Timeline />

    ),
  },
  {
    path: "/all-products",
    element: (

      <AllProduct />

    ),
  },


  /////////////////////////Web///////////////////////////////
  {
    path: "/banners",
    element: (
      <ProtectedRoute>
        <BannerPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/marquee",
    element: (
      <ProtectedRoute>
        <MarqueePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/market-places",
    element: (
      <ProtectedRoute>
        <MarketPlacesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/offers",
    element: (
      <ProtectedRoute>
        <OffersPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/product/categories",
    element: (
      <ProtectedRoute>
        <ProductCategoryPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/contact-us",
    element: (
      <ProtectedRoute>
        <ContactUsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/about-us",
    element: (
      <ProtectedRoute>
        <AboutUsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/brands",
    element: (
      <ProtectedRoute>
        <BrandsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/blogs",
    element: (
      <ProtectedRoute>
        <BlogListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/blogs/create",
    element: (
      <ProtectedRoute>
        <BlogFormPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/blogs/edit/:id",
    element: (
      <ProtectedRoute>
        <BlogFormPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/services",
    element: (
      <ProtectedRoute>
        <ServicesListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/services/create",
    element: (
      <ProtectedRoute>
        <ServiceFormPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/services/edit/:id",
    element: (
      <ProtectedRoute>
        <ServiceFormPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/site-settings",
    element: (
      <ProtectedRoute>
        <SiteSettingsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/privacy-policy",
    element: (
      <ProtectedRoute>
        <PrivacyPolicyPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/return-exchange",
    element: (
      <ProtectedRoute>
        <ReturnExchangePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/terms-condition",
    element: (
      <ProtectedRoute>
        <TermsConditionsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/faqs-page",
    element: (
      <ProtectedRoute>
        <FaqsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/expenses-type",
    element: (
      <ProtectedRoute >
        <ExpenseTypesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/daily-expenses",
    element: (
      <ProtectedRoute >
        <DailyExpensesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/users",
    element: (
      <ProtectedRoute permission="Users view">
        <UserIndex />
      </ProtectedRoute>
    ),
  },
  {
    path: "/user-create",
    element: (
      <ProtectedRoute permission="Users create">
        <UserCreate />
      </ProtectedRoute>
    ),
  },
  {
    path: "/user-edit/:id",
    element: (
      <ProtectedRoute permission="Users edit">
        <UserEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/users-roles",
    element: (
      <ProtectedRoute permission="User roles view">
        <RoleIndex />
      </ProtectedRoute>
    ),
  },
  {
    path: "/role-create",
    element: (
      <ProtectedRoute permission="User roles create">
        <RoleCreate />
      </ProtectedRoute>
    ),
  },
  {
    path: "/role-edit/:id",
    element: (
      <ProtectedRoute permission="User roles edit">
        <RoleEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/vendor-list",
    element: (
      <ProtectedRoute permission="vendor.view">
        <VendorsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/vendor-show/:id",
    element: (
      <ProtectedRoute permission="vendor.view">
        <VendorShow />
      </ProtectedRoute>
    ),
  },
  {
    path: "/products-list",
    element: (
      <ProtectedRoute permission="Products view">
        <ProductPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/product-create",
    element: (
      <ProtectedRoute permission="Products create">
        <ProductCreatePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/product-edit/:slug",
    element: (
      <ProtectedRoute permission="Products edit">
        <ProductEditPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/product-show/:id",
    element: (
      <ProtectedRoute permission="Products view">
        <ProductShowPage />
      </ProtectedRoute>
    ),
  },






  {
    path: "/expense-select",
    element: <ExpenseTypeSelect />,
  },

  {
    path: "/expense-create/:type",
    element: <ExpenseEntry />,
  },
  {
    path: "/expense-list",
    element: (

      <ExpenseList />
    ),
  },
  {
    path: "/stock",
    element: (
      // <ProtectedRoute>
      <StockIndex />
      // </ProtectedRoute>
    ),
  },
  {
    path: "/stock/show/:productId",
    element: (
      // <ProtectedRoute>
      <StockShow />
      // </ProtectedRoute>
    ),
  },

  //////////// Settings//////
  {
    path: "/product-categories",
    element: (
      <ProtectedRoute permission="Settings">
        <ProductCategoriesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/payment-methods",
    element: (
      <ProtectedRoute permission="Settings">
        <PaymentMethodsPage />
      </ProtectedRoute>
    ),
  },
]);
document.addEventListener("wheel", (e) => {
  if (document.activeElement.type === "number") {
    document.activeElement.blur()
  }
})
createRoot(document.getElementById("root")).render(
  <ThemeProvider>
    <LoaderProvider>
      <TranslatorProvider>
        <SidebarProvider>
          <AuthProvider>
            <ValidationProvider>
              <RouterProvider router={router} />
            </ValidationProvider>
          </AuthProvider>
        </SidebarProvider>
      </TranslatorProvider>
    </LoaderProvider>
  </ThemeProvider>,
);
